import BARANSKA_EXT_1 from "./BARANSKA_EXT_1";

export default {
  BARANSKA_EXT_1,
};
